import { getYear } from 'date-fns';

type FooterProps = {
  onWhyPrepareConsultationClick: () => void;
  onWhatIsAldebaranClick: () => void;
};

export const Footer = ({
  onWhyPrepareConsultationClick,
  onWhatIsAldebaranClick,
}: FooterProps) => {
  return (
    <div className="hidden nsm:flex flex-col gap-3 pb-3 w-full pt-7 mt-2">
      <div className="flex flex-row items-center justify-center gap-12">
        <button
          className="text-xs cursor-pointer text-center"
          onClick={onWhyPrepareConsultationClick}
        >
          Pourquoi préparer sa consultation ?
        </button>
        <button
          className="text-xs cursor-pointer text-center"
          onClick={onWhatIsAldebaranClick}
        >
          C&apos;est quoi Aldebaran ?
        </button>
        <a
          href="https://aldebaran.care/patient/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs cursor-pointer text-center"
        >
          Mes informations de santé sont protégées ?
        </a>
      </div>
      <p className="text-2xs text-center font-light">
        Aldebaran protège vos données selon les normes en vigueur en France et
        dans l&apos;Union Européenne <br /> Pour en savoir plus, consultez notre{' '}
        <a
          href="https://aldebaran.care/legal/politique-protection-donnees"
          target="_blank"
          rel="noopener noreferrer"
          className="text-2xs underline font-light cursor-pointer"
        >
          <span>politique de confidentialité</span>
        </a>
        . © {getYear(new Date())} Aldebaran 70 Rue du Docteur Yersin 59120 LOOS
      </p>
    </div>
  );
};
